(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-dart"] && !Shopify.designMode) return;
  try {
    (function () {
    var flight = document.querySelector('.flight');
    if (!flight) return;
    var dart = flight.querySelector('.flight__dart');
    var trailSvg = flight.querySelector('.flight__trail');
    var trailPath = flight.querySelector('.flight__trail-path');

    var W = 0, H = 0, pathLen = 0;
    var WAVES = 5;          // number of weaves down the page
    var X_CENTER = 0.88;    // horizontal centre of the weave (within content width)
    var X_AMP = 0.05;       // weave amplitude
    var ticking = false;

    function xAt(p) { return (X_CENTER + X_AMP * Math.sin(p * Math.PI * 2 * WAVES)) * W; }
    function yAt(p) { return p * H; }

    function buildTrail() {
      W = flight.clientWidth;
      H = flight.clientHeight;
      trailSvg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var d = 'M ' + xAt(0).toFixed(1) + ' ' + yAt(0).toFixed(1);
      var steps = 120;
      for (var i = 1; i <= steps; i++) {
        var p = i / steps;
        d += ' L ' + xAt(p).toFixed(1) + ' ' + yAt(p).toFixed(1);
      }
      trailPath.setAttribute('d', d);
      pathLen = trailPath.getTotalLength();
      trailPath.style.strokeDasharray = pathLen;
      trailPath.style.strokeDashoffset = pathLen;
    }

    function update() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      var p = scrollable > 0 ? window.scrollY / scrollable : 0;
      if (p < 0) p = 0; if (p > 1) p = 1;

      var x = xAt(p), y = yAt(p);
      // tangent for rotation (downward motion with horizontal weave)
      var dx = X_AMP * Math.cos(p * Math.PI * 2 * WAVES) * Math.PI * 2 * WAVES * W;
      var dy = H;
      var angle = Math.atan2(dy, dx) * 180 / Math.PI; // ~90deg, tilts with weave
      dart.style.transform = 'translate(' + x + 'px, ' + y + 'px) translate(-50%, -50%) rotate(' + angle + 'deg)';
      trailPath.style.strokeDashoffset = (pathLen * (1 - p)).toFixed(1);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    function onResize() {
      // Stop the flight path just above the footer so the dart never overlaps it
      var footer = document.querySelector('.footer');
      var stopAt = footer ? (footer.getBoundingClientRect().top + window.scrollY) : document.documentElement.scrollHeight;
      flight.style.height = stopAt + 'px';
      buildTrail();
      update();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    if (document.readyState === 'complete') {
      onResize();
    } else {
      window.addEventListener('load', onResize);
      // build once now too in case load already fired styling
      setTimeout(onResize, 300);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var ticking = false;
    function reveal() {
      var trigger = window.innerHeight * 0.9;
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
        // Reveal when near/in the viewport, or already scrolled past (robust to jump-scrolls)
        if (el.getBoundingClientRect().top < trigger) {
          el.classList.add('is-visible');
        }
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(reveal); ticking = true; }
    }
    function init() {
      reveal();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('load', reveal);
  })();
  } catch(e) { console.error(e); }
})();

})();
